import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Control, Errors, actions } from 'react-redux-form';
import { FormGroup, FormControl, Row, Col, Radio } from 'react-bootstrap';
import FileDownload from 'react-file-download'
import { dateFormat } from '../../../../utils/commonFunctions'
import irelandApi from '../../../../irelandApi'
import PageTitle from '../../../common/page-title';
import RequiredDatePicker from '../../../common/form/elements/required-datepicker';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredMultiSelect from '../../../common/form/elements/required-multi-select'
import MultiSelect from '../../../common/form/multi-select'
import ArrowButton from '../../../common/button-arrow';
import BackLink from '../../../common/back-link/index';
import { getIncentive, updateIncentive, saveIncentive } from '../../../../actions/incentives';
import FileUpload from '../../../common/form/elements/file-upload';
import ImageUpload from '../../../common/form/elements/image-upload';

import './styles.css';

class AddIncentives extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pack: "Packs Sold",
      rewardType: "Points",
      disabled: false,
      incentiveTypes: '',
      incentiveRewardTypes: '',
      productList: '',
      groupList: ''
    };
  }

  handleAddMore = (event) => {
    this.setState({pack: event.target.value})

    if (event.target.value === 'fixed_target') {
      this.props.dispatch(actions.change('deep.incentives.reward_type', 'points'));
    }
  };

  handleRewardTypeChange = (event) => {
    this.setState({rewardType: event.target.value})
  };

  componentWillMount() {
    this.id = +this.props.match.params.id;
    this.newIncentive = isNaN(this.id)
    this.fieldDisabled = !this.newIncentive && this.props.startDateBeforeCurrentDate
    this.edit = !this.newIncentive
    this.props.dispatch(getIncentive(this.id));
    if (!this.newIncentive) {
      this.props.dispatch(actions.reset('deep.incentives'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.incentives'));
  }

  createProductList = (products) => {
    return products.map((curr) => {
      return {
        label: `${curr.sku_name} ${curr.sku_code}`,
        value: curr.id
      }
    });
  };

  createGroupList = (groups) => {
    return groups.map((curr) => {
      return {
        label: `${curr.name}`,
        value: curr.id
      }
    });
  };

  renderIncentiveTypes = () => {
    const {incentiveTypes} = this.props;
    return Object.keys(incentiveTypes).map(curr => {
      return (
        <Col key={curr} md={3} sm={6} xs={12}>
          <Control.radio
            model={`deep.incentives.kind`}
            disabled={this.fieldDisabled}
            value={curr}
            component={Radio}
            onChange={this.handleAddMore}>{incentiveTypes[curr]}</Control.radio>
        </Col>
      );
    })
  };

  renderIncentiveRewardTypes = () => {
    const { incentiveRewardTypes, kind } = this.props;

    return Object.keys(incentiveRewardTypes).map(curr => {
      return (
        <Col key={curr} md={3} sm={6} xs={12}>
          <Control.radio
            model={`deep.incentives.reward_type`}
            disabled={this.fieldDisabled || (curr === "prize" && kind === 'fixed_target')}
            value={curr}
            component={Radio}
            onChange={this.handleRewardTypeChange}>{incentiveRewardTypes[curr]}</Control.radio>
        </Col>
      );
    })
  };

  onSubmit = (formData) => {
    let { start_date_before_current_date, ...data } = formData

    const {dispatch} = this.props;
    if (this.edit) {
      dispatch(updateIncentive(this.props.incentive.id, data));
    } else {
      dispatch(saveIncentive(data));
    }
  };

  downloadCSV = () => {
    irelandApi.get(`/api/admin/incentives/${this.props.incentive.id}/download`, {headers: {'Accept': 'text/csv'}})
              .then((response) => {
                FileDownload(response.data, 'unprocessed_ppc_orders.csv');
              })
              .catch((error) => {

              })
  };

  prizeFields = () => {
    const image = this.props.formData.prize_image_link;

    return (
      <div>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Prize name*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              model=".prize_name"
              placeholder="Prize Name"
              controlId="prizeName"/>
          </Col>
        </Row>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Prize description*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              model=".prize_description"
              placeholder="Prize Description"
              controlId="prizeDescription"/>
          </Col>
        </Row>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Prize image*</h4>
          </Col>
          <Col md={9}>
            <ImageUpload
              onImageLoaded={this.onImageLoaded}
              source={image}
              sizeLimit={1024 * 1024}
              type={['image/png', 'image/jpg', 'image/jpeg']}
              model=".prize_image"
              required
              />
          </Col>
        </Row>
      </div>
    );
  };

  packsSoldFields = () => {
    return (
      <div>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Target*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              disabled={this.fieldDisabled}
              model=".target"
              placeholder="Target"
              controlId="target"/>
          </Col>
        </Row>
        {this.props.reward_type === 'points' && (
          <div>
            <Row>
              <Col md={3} className="add-incentives">
                <h4>Points To Target*</h4>
              </Col>
              <Col md={9}>
                <RequiredInput
                  disabled={this.fieldDisabled}
                  model=".points_to_target"
                  placeholder="Points To Target"
                  controlId="pointToTarget"/>
              </Col>
            </Row>
            <Row>
              <Col md={3} className="add-incentives">
                <h4>Points After Target*</h4>
              </Col>
              <Col md={9}>
                <RequiredInput
                  disabled={this.fieldDisabled}
                  model=".points_after_target"
                  placeholder="Points After Target"
                  controlId="pointsAfterTarget"/>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  };

  percentageIncreaseFields = () => {
    return (
      <div>
        <Row>
          <Col md={3}>
            <h4>% Calculation From Date*</h4>
          </Col>
          <Col md={9}>
      <RequiredDatePicker model="deep.incentives.percentage_calculate_from"
                                disabled={this.fieldDisabled}
                                controlId="percentage_calculate_from"
                                value={this.props.percentageCalculateFrom}/>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <h4>% Calculation to Date*</h4>
          </Col>
          <Col md={9}>
      <RequiredDatePicker model="deep.incentives.percentage_calculate_to"
                                disabled={this.fieldDisabled}
                                controlId="percentage_calculate_to"
                                value={this.props.percentageCalculateTo}/>
          </Col>
        </Row>
        <Row>
        <Col md={3} className="add-incentives">
          <h4>Target (%)*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={this.fieldDisabled}
            model=".target"
            placeholder="Target (%)"
            controlId="target"/>
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Default target*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={this.fieldDisabled}
            model=".default_target"
            placeholder="Default target"
            controlId="defaultTarget"/>
        </Col>
      </Row>
      {this.props.reward_type == 'points' && (
        <div>
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Points To Target*</h4>
            </Col>
            <Col md={9}>
              <RequiredInput
                disabled={this.fieldDisabled}
                model=".points_to_target"
                placeholder="Points To Target"
                controlId="pointToTarget"/>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Points After Target*</h4>
            </Col>
            <Col md={9}>
              <RequiredInput
                disabled={this.fieldDisabled}
                model=".points_after_target"
                placeholder="Points After Target"
                controlId="pointsAfterTarget"/>
            </Col>
          </Row>
        </div>
      )}
      </div>
    );
  };

  baseTargetFields = () => {
    return (
      <div>
        {!this.edit && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Upload Target 1*</h4>
            </Col>
            <Col md={9}>
              <FileUpload required/>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Target 2 (%)*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              disabled={this.fieldDisabled}
              model=".target"
              placeholder="Target 2 (%)"
              controlId="target"/>
          </Col>
        </Row>
        {this.props.reward_type === 'points' && (
          <div>
            <Row>
              <Col md={3} className="add-incentives">
                <h4>Points To Target 1*</h4>
              </Col>
              <Col md={9}>
                <RequiredInput
                  disabled={this.fieldDisabled}
                  model=".points_to_target"
                  placeholder="Points To Target 1"
                  controlId="pointToTarget"/>
              </Col>
            </Row>
            <Row>
              <Col md={3} className="add-incentives">
                <h4>Points To Target 2*</h4>
              </Col>
              <Col md={9}>
                <RequiredInput
                  disabled={this.fieldDisabled}
                  model=".points_to_target_2"
                  placeholder="Points To Target 2"
                  controlId="pointToTarget"/>
              </Col>
            </Row>
            <Row>
              <Col md={3} className="add-incentives">
                <h4>Points After Target*</h4>
              </Col>
              <Col md={9}>
                <RequiredInput
                  disabled={this.fieldDisabled}
                  model=".points_after_target"
                  placeholder="Points After Target"
                  controlId="pointsAfterTarget"/>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  };

  fixedTargetFields = () => {
    return (
      <div>
        {!this.edit && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Upload Targets*</h4>
            </Col>
            <Col md={9}>
              <FileUpload required/>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Points At Target 1*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              disabled={this.fieldDisabled}
              model=".points_to_target"
              placeholder="Points At Target 1"
              controlId="pointToTarget"/>
          </Col>
        </Row>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Points At Target 2</h4>
          </Col>
          <Col md={9}>
            <FormGroup controlId="pointToTarget2">
              <Control.text model=".points_to_target_2"
                            disabled={this.fieldDisabled}
                            placeholder="Points At Target 2"
                            component={FormControl}/>
              <Errors
                show={{touched: true, focus: false}}
                className="errors"
                model=".points_to_target_2"
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  };
  commonFields = () => {
    let requiredGroup = this.props.endDate &&
                        this.props.displayTo &&
                        dateFormat(this.props.endDate) < dateFormat(new Date()) &&
                        dateFormat(this.props.displayTo) < dateFormat(new Date()) ?
                        false : true;

    let groupMultiSelect = requiredGroup ?
      <div>
        <RequiredMultiSelect
          data={this.createGroupList(this.props.groups)}
          value={this.props.savedGroups}
          controlId="groups"
          model='deep.incentives.group_ids'
          withAllOption={true} />
      </div> :
      <div>
        <MultiSelect
          data={this.createGroupList(this.props.groups)}
          value={this.props.savedGroups}
          controlId="groups"
          model='deep.incentives.group_ids'
          withAllOption={true} />
      </div>;

    return (
      <div>
        {this.props.reward_type === 'points' && this.props.kind !== 'fixed_target' && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Max Points Per Outlet</h4>
            </Col>
            <Col md={9}>
              <FormGroup controlId="maxPointsPerOutlet">
                <Control.text model=".maximum_points"
                              disabled={this.fieldDisabled}
                              placeholder="Max Points Per Outlet"
                              component={FormControl}/>
                <Errors
                  show={{touched: true, focus: false}}
                  className="errors"
                  model=".maximum_points"
                />
              </FormGroup>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={3}>
            <h4>Display From Date*</h4>
          </Col>
          <Col md={9}>
            <RequiredDatePicker model="deep.incentives.display_from"
                                controlId="display_from'"
                                value={this.props.displayFrom}
                                />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <h4>Display To Date*</h4>
          </Col>
          <Col md={9}>
            <RequiredDatePicker model="deep.incentives.display_to"
                                controlId="display_to'"
                                value={this.props.displayTo}/>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <h4>{`${requiredGroup ? 'Eligible Groups*' : 'Eligible Group'}`}</h4>
          </Col>
          <Col md={9}>
            {groupMultiSelect}
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    let multiselect = (
      <div>
        <RequiredMultiSelect
          data={this.createProductList(this.props.products)}
          value={this.props.savedProducts}
          disabled={this.fieldDisabled}
          controlId="products"
          model='deep.incentives.product_ids'/>
      </div>);

    return (
      <div className="container-fluid incentive-form">

        <Row>
          <Col md={12}>
            <BackLink href="/admin/sales_incentives"/>

            <PageTitle>{`${this.edit ? 'View' : 'Add'} sales incentive`}</PageTitle>
            { this.edit &&
            <ArrowButton submit={false}
                         arrow={false}
                         className="pull-right"
                         permissions={{
                           action: 'generate-points-export',
                           subjectClass: 'Incentive'
                         }}
                         onClick={this.downloadCSV}>Generate points import</ArrowButton>
            }
          </Col>
        </Row>
        <Col md={12}>
          <Row>
            <Form model="deep.incentives" onSubmit={this.onSubmit}>

              <Errors className="errors" model="deep.incentives"/>
              <Row>
                <Col md={3} className="add-incentives">
                  <h4>Incentive Name*</h4>
                </Col>
                <Col md={9}>
                  <RequiredInput
                    model=".name"
                    placeholder="Incentive Name"
                    controlId="loadPoints"/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Audience*</h4>
                </Col>
                <Col md={9}>
                  <Row>
                    <Col md={3} sm={6} xs={12}>
                      <Control.radio
                        model={`deep.incentives.audience`}
                        value="retailers"
                        component={Radio}
                        disabled={this.fieldDisabled}
                        onChange={() => {}}
                      >
                        Retailers
                      </Control.radio>
                    </Col>
                    <Col md={4} sm={6} xs={12}>
                      <Control.radio
                        model={`deep.incentives.audience`}
                        value="account_managers"
                        component={Radio}
                        disabled={this.fieldDisabled}
                        onChange={() => {}}
                      >
                        Account Managers
                      </Control.radio>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Incentive Start Date*</h4>
                </Col>
                <Col md={9}>
                  <RequiredDatePicker disabled={this.fieldDisabled}
                                      model="deep.incentives.start_date"
                                      controlId="start_date"
                                      value={this.props.startDate}/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Incentive End Date*</h4>
                </Col>
                <Col md={9}>
                  <RequiredDatePicker model="deep.incentives.end_date"
                                      controlId="end_date"
                                      value={this.props.endDate}/>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Eligible SKUs*</h4>
                </Col>
                <Col md={9}>
                  {multiselect}
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Incentive Type*</h4>
                </Col>
                <Col md={9}>
                  <Row>
                    { this.renderIncentiveTypes() }
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <h4>Incentive Reward Type*</h4>
                </Col>
                <Col md={9}>
                  <Row>
                    { this.renderIncentiveRewardTypes() }
                  </Row>
                </Col>
              </Row>
              { this.props.reward_type === "prize" && this.prizeFields() }
              { this.props.kind === "base_target" && this.baseTargetFields() }
              { this.props.kind === "packs_sold" && this.packsSoldFields() }
              { this.props.kind === "percentage_increase" && this.percentageIncreaseFields() }
              { this.props.kind === "fixed_target" && this.fixedTargetFields() }
              { this.commonFields() }

              <Col md={12}>
                <Row>
                  <ArrowButton className="float-right" color="red" disabled={!this.props.formValid || this.props.fetching}>save</ArrowButton>
                </Row>
              </Col>
            </Form>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formData: state.deep.incentives,
    formValid: state.deep.forms.incentives.$form.valid,
    incentive: state.incentives.incentive,
    displayFrom: state.deep.incentives.display_from || '',
    displayTo: state.deep.incentives.display_to || '',
    percentageCalculateFrom: state.deep.incentives.percentage_calculate_from || '',
    percentageCalculateTo: state.deep.incentives.percentage_calculate_to || '',
    startDate: state.deep.incentives.start_date || '',
    endDate: state.deep.incentives.end_date || '',
    kind: state.deep.incentives.kind || '',
    audience: state.deep.audience || '',
    reward_type: state.deep.incentives.reward_type || '',
    savedProducts: state.deep.incentives.product_ids || [],
    savedGroups: state.deep.incentives.group_ids || [],
    startDateBeforeCurrentDate: state.deep.incentives.start_date_before_current_date || false,
    meta: state.incentives.meta,
    incentiveTypes: state.incentives.meta["incentive-types"] || {},
    incentiveRewardTypes: state.incentives.meta["incentive-reward-types"] || {},
    products: state.incentives.meta.products || [],
    groups: state.incentives.meta.groups || [],
    fetching: state.incentives.fetching,
    fetched: state.incentives.fetched
  };
};

export default connect(mapStateToProps)(AddIncentives);



// WEBPACK FOOTER //
// ./src/components/admin/incentives/add-incentives/index.jsx